<app-modal-option-panel>
  <div class="register">
    @if (!verifyFailed) {
      <div class="input-el flex-column">
        <div class="succ-icon">
          <img
            [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/registration_icon_success.svg'" />
        </div>
        <h3>{{ languageService.languageJSON.AccountDialog_Success }}</h3>
        <h5 class="h5-succ">{{
          languageService.languageJSON.AccountDialog_Verification_Success_Description }}</h5>
      </div>
    }
    @if (verifyFailed) {
      <div class="input-el flex-column">
        <div class="failed-icon">
          <img [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/cancel_icon.svg'" />
        </div>
        <h3>{{ languageService.languageJSON.AccountDialog_Verification_Error }}</h3>
        <h5 class="h5-failed">
          {{ languageService.languageJSON.AccountDialog_Verification_Error_Description }}
        </h5>
      </div>
    }
  </div>
</app-modal-option-panel>
